/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.Dialog = function( config, parentElement, overlayElement) {
    var FxEvent = expocadfx.fxevent;
    var fxStyle = expocadfx.styles;
    var doc = window.document;
    var parent = parentElement;
    var mask = overlayElement;
    var lastX = 0;
    var lastY = 0;
    var i = 0;
    var dialogWidth = Math.min( config.width, doc.documentElement.clientWidth -8);
    var dialogHeight = Math.min( config.height, doc.documentElement.clientHeight -8);
    var contentHeight = dialogHeight - 33;
    
    var dialog = doc.createElement( "div");
    var header = doc.createElement( "div");
    var contentArea = doc.createElement( "div");
    var action = doc.createElement( "div");
    var but = null;
    
    dialog.className = "dialog";
    parent.appendChild( dialog);
    
    if( config.posX + dialogWidth > doc.documentElement.clientWidth) {
        config.posX = 4;
    }
    if( config.posY + dialogHeight > doc.documentElement.clientHeight) {
        config.posY = 4;
    }
    dialog.style.left = config.posX + "px";
    dialog.style.top = config.posY + "px";
    
    dialog.style.width = dialogWidth + "px";
    dialog.style.height = dialogHeight + "px";
    
    header.className = "dialog__header unselectable";
    dialog.appendChild( header);
    header.textContent = config.title;
    header.style.color = config.headerTextColor;
    
    header.style.backgroundColor = config.headerBackgroudColor;


    dialog.style.backgroundColor = fxStyle.rows.clrEvenBg;
    dialog.style.color = fxStyle.rows.clrEvenText;
    
    if( config.cancelLabel !== null) {
        contentHeight -= 52;
    }
    
    contentArea.className = "dialog__content scrollbar";
    dialog.appendChild( contentArea);
    
    contentArea.style.height = contentHeight + "px";
    
    action.className = "dialog__actions";
    dialog.appendChild( action);
    
    if( config.rightButton) {
//        add 'right' button before (to right of) close/cancel button
        but = doc.createElement( "button");
        but.className = "right";
        but.textContent = config.rightButton.label;
        but.setAttribute( "id", config.rightButton.id);
        action.appendChild( but);
    }
    //  ?? miniMap with no close button or any actions ??
    //readded mini map
   // if( config.cancelLabel !== null) {
        but = doc.createElement( "button");
        but.className = "right closeBtn";
        but.textContent = config.cancelLabel;
        action.appendChild( but);
        but.addEventListener( "click", closeDialog);

        but2 = doc.createElement("button");
        but2.className = "Xtop closeBtn";
        but2.textContent = "X";
        action.appendChild( but2);
        but2.addEventListener( "click", closeDialog);

   // }
    if( config.leftButtons) {
        //create buttons for left side and add function or event for each
        for( i = 0; i < config.leftButtons.length; i++) {
            but = doc.createElement( "button");
            but.className = "left";
            but.textContent = config.leftButtons[i].label;
            but.setAttribute( "id", config.leftButtons[i].id);
            action.appendChild( but);
        }
    }
    
    if( config.draggable) {
        header.addEventListener( "pointerdown", dragStart);
        header.addEventListener( "mousedown", dragStart);
        header.addEventListener( "touchstart", dragStart);
    }
    else {
        mask.style.display = "block";
    }
    
    function dragStart( evt) {
        evt.preventDefault();
        if( evt.type === "touchstart") {
            lastX = evt.touches[0].clientX;
            lastY = evt.touches[0].clientY;
        }
        else {
            lastX = evt.pageX;
            lastY = evt.pageY;
        }
        mask.style.display = "block";
        document.addEventListener( "pointermove", dragMove);
        document.addEventListener( "mousemove", dragMove);
        document.addEventListener( "touchmove", dragMove);
        document.addEventListener( "pointerup", dragEnd);
        document.addEventListener( "mouseup", dragEnd);
        document.addEventListener( "touchend", dragEnd);
//        document.addEventListener( "mouseout", dragEnd);
        return false;
    }
    
    function dragMove( evt) {
        evt.preventDefault();
        var dx = 0;
        var dy = 0;
        
        if( evt.type === "touchmove") {
            dx = evt.touches[0].clientX - lastX;
            dy = evt.touches[0].clientY - lastY;
        }
        else {
            dx = evt.pageX - lastX;
            dy = evt.pageY - lastY;
        }
        if( Math.abs(dx) + Math.abs(dy) < 10) {
            return;     // didn't move enough to be a drag
        }
        //  check bounds
        if( dialog.offsetLeft + dialog.offsetWidth + dx > parent.clientWidth) {
            dx = parent.clientWidth - dialog.offsetLeft - dialog.offsetWidth;
        }
        if( dialog.offsetTop + dialog.offsetHeight + dy > parent.clientHeight) {
            dy = parent.clientHeight - dialog.offsetTop - dialog.offsetHeight;
        }
        if( dialog.offsetLeft + dx < 0) {
            dx = dialog.offsetLeft;
        }
        if( dialog.offsetTop + dy < 0) {
            dy = dialog.offsetTop;
        }
        dialog.style.left = dialog.offsetLeft + dx + "px";
        dialog.style.top = dialog.offsetTop + dy + "px";
        
        if( evt.type === "touchstart") {
            lastX = evt.touches[0].clientX;
            lastY = evt.touches[0].clientY;
        }
        else {
            lastX = evt.pageX;
            lastY = evt.pageY;
        }
        
        dialog.dispatchEvent( new FxEvent( "Dialog_Moved", {}));
    }
    
    function dragEnd() {
        document.removeEventListener( "pointermove", dragMove);
        document.removeEventListener( "mousemove", dragMove);
        document.removeEventListener( "touchmove", dragMove);
        document.removeEventListener( "pointerup", dragEnd);
        document.removeEventListener( "mouseup", dragEnd);
        document.removeEventListener( "touchend", dragEnd);
//        document.removeEventListener( "mouseout", dragEnd);
        mask.style.display = "none";
    }
    
    function closeDialog() {
        mask.style.display = "none";
        dialog.style.display = "none";
        dialog.dispatchEvent( new FxEvent( "Dialog_Closed", {}));
    }
    
    function openDialog() {
        if( !config.draggable) {
            mask.style.display = "block";
        }
        dialog.style.display = "block";
    }
    
    return {
        window: dialog,
        header: header,
        close: closeDialog,
        action:action,
        content: contentArea,
		open: openDialog
    };
};